import React from 'react';
import styled from 'styled-components';
import { Form } from '../../../styles/Form';
export default function ConfigFormNumber({ value, onChange, min = '0', step = '1', width, className, }) {
    return (React.createElement(StyledConfigForm, { className: className, type: "number", min: min, step: step, onChange: onChange, value: value, width: width }));
}
const StyledConfigForm = styled(Form) `
  width: 100%;
  box-sizing: border-box;
  ${(props) => props.width &&
    `
    width: ${props.width}px;
  `}
`;
